"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaymentChannelUid = void 0;
const ethers_1 = require("ethers");
const constants_1 = require("../constants");
function createPaymentChannelUid(salt = null) {
    return ethers_1.utils.solidityKeccak256(['string'], [salt || constants_1.DEFAULT_PAYMENT_CHANNEL_UID_SALT]);
}
exports.createPaymentChannelUid = createPaymentChannelUid;
